export default {"src":"/uk/_next/static/media/spot-youtube-video.c68a330c.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};